import { PublicHoliday } from './../../../../admin/model/public-holiday.model';
import {Pagination} from '../pagination.model';

export class PublicHolidayPage extends Pagination {
  content: PublicHoliday[] = [];
}
